import React from 'react';

export default props => {
    const id = props.id || '_' + props.value;
    return (
        <label htmlFor={id}>
            {props.placeholder}
            <input type="radio" />
        </label>
    );
};



// WEBPACK FOOTER //
// ./src/components/RadioRow.tsx